"use client";

import Link from "next/link";
import { useT } from "@tillix/i18n/react";
import { Button } from "@tillix/ui-atoms/button";
import { cn } from "@tillix/ui-atoms/lib/utils";

interface QuickPayButtonProps {
  className?: string;
}
export const QuickPayButton: React.FC<QuickPayButtonProps> = ({
  className,
}) => {
  const { t } = useT();
  return (
    <Button
      className={cn("w-full lg:size-lg", className)}
      render={<Link href="/quick-pay" />}
      size="default"
    >
      {t("auth.quickPay")}
    </Button>
  );
};
